import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Box, LinearProgress, Typography, Snackbar } from '@mui/material';
import { useAppSelector } from '../../../../Redux/Hooks';

const ProgressSnackbar: React.FC = () => {
    const { uploadFolderProgress, currentCompressingFolder } = useAppSelector((state) => state.album);


    return (
        <Fragment>
            {
                uploadFolderProgress
                && uploadFolderProgress.length > 0
                && uploadFolderProgress.map((data, index) =>
                    <Snackbar
                        key={index}
                        open={data.totalProgress > 0 && data.totalProgress < 100}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        style={{ bottom: 100 * index + 20 }}
                    >
                        <Box
                            sx={{
                                minWidth: '250px',
                                p: 2,
                                backgroundColor: '#fff',
                                boxShadow: 1,
                                borderRadius: 1,
                            }}
                        >
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                {data.folderName}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                {data.totalProgress.toFixed(2)}% Images Uploaded
                            </Typography>
                            {/* <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#6b6b6b' }}>
                                Upload continues. You can keep working.
                            </Typography> */}
                            {/* <Typography variant="body2" sx={{ mb: 1 ,color:"green",fontSize:"10px"}}>
                                    You can continue your work.
                                </Typography> */}
                            <LinearProgress
                                variant="determinate"
                                value={data.totalProgress}
                                sx={{
                                    height: 8,
                                    borderRadius: 999,
                                    backgroundColor: '#F1E8F3',
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: '#AE2AB1',
                                        borderRadius: 999,
                                    },
                                }}
                            />
                        </Box>
                    </Snackbar>
                )


            }

            {
                currentCompressingFolder
                && currentCompressingFolder.length > 0
                && currentCompressingFolder.map((data, index) => {
                    // console.log(uploadFolderProgress.length + index)
                    return (

                        <Snackbar
                            key={index}
                            open={data.totalProgress > 0 && data.totalProgress < 100}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            style={{ bottom: (100 * (uploadFolderProgress.length + index)) + 20 }}
                        >
                            <Box
                                sx={{
                                    minWidth: '250px',
                                    p: 2,
                                    backgroundColor: '#fff',
                                    boxShadow: 1,
                                    borderRadius: 1,
                                }}
                            >
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    {data.folderName}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    {data.totalProgress.toFixed(2)}% Images Compressed
                                </Typography>
                                {/* <Typography variant="body2" sx={{ mb: 1 ,color:"red",fontSize:"10px"}}>
                                    Please don't change screen while compressing!!
                                </Typography> */}
                                <LinearProgress
                                    variant="determinate"
                                    value={data.totalProgress}
                                    sx={{
                                        height: 8,
                                        borderRadius: 999,
                                        backgroundColor: '#F1E8F3',
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#AE2AB1',
                                            borderRadius: 999,
                                        },
                                    }}
                                />
                            </Box>
                        </Snackbar>
                    )
                }
                )


            }

        </Fragment>
    );
};

export default ProgressSnackbar;
